/* istanbul ignore file */

import type { ChangeEvent } from 'react';
import React from 'react';
import { RadioDial } from '@noths/polaris-client-ribbons-design-system';

import { RADIO_BUTTON__LABEL_CLASS, RADIO_BUTTON__LABEL_TEXT_CLASS } from '../constants/classNames';
import * as styles from '../styles/RadioButton.styles';

export type RadioButtonProps = {
  labelText: string;
  name?: string;
  value: string;
  checked?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const RadioButton = ({
  labelText,
  name,
  value,
  checked = false,
  onChange,
}: RadioButtonProps) => (
  <label css={styles.radioButtonWrapper} className={RADIO_BUTTON__LABEL_CLASS}>
    <RadioDial
      name={name}
      value={value}
      checked={checked}
      onChange={onChange}
      aria-label={labelText}
    />
    <span
      css={styles.radioButtonLabelText}
      className={RADIO_BUTTON__LABEL_TEXT_CLASS}
      aria-hidden="true"
    >
      {labelText}
    </span>
  </label>
);
